import React from "react";

// SVG-based animated automation network — flow lines + pulsing nodes
export function NetworkBackground() {
  const nodes = [
    { x: 120, y: 140 }, { x: 320, y: 90 }, { x: 540, y: 180 },
    { x: 760, y: 110 }, { x: 1000, y: 200 }, { x: 1200, y: 130 },
    { x: 220, y: 360 }, { x: 460, y: 420 }, { x: 700, y: 360 },
    { x: 920, y: 460 }, { x: 1140, y: 400 }, { x: 380, y: 600 },
    { x: 620, y: 660 }, { x: 860, y: 620 }, { x: 1080, y: 680 },
  ];

  const edges = [
    [0, 1], [1, 2], [2, 3], [3, 4], [4, 5],
    [0, 6], [1, 7], [2, 8], [3, 9], [4, 10],
    [6, 7], [7, 8], [8, 9], [9, 10],
    [7, 11], [8, 12], [9, 13], [10, 14],
    [11, 12], [12, 13], [13, 14],
    [6, 11], [11, 7],
  ];

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      {/* gradient base */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at 70% 30%, rgba(0,229,255,0.10), transparent 55%), radial-gradient(ellipse at 20% 80%, rgba(0,92,107,0.25), transparent 60%), #0B132B",
        }}
      />
      {/* grid */}
      <svg className="absolute inset-0 w-full h-full opacity-[0.07]" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="grid" width="56" height="56" patternUnits="userSpaceOnUse">
            <path d="M 56 0 L 0 0 0 56" fill="none" stroke="#ffffff" strokeWidth="0.5" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#grid)" />
      </svg>

      {/* network */}
      <svg
        viewBox="0 0 1280 780"
        preserveAspectRatio="xMidYMid slice"
        className="absolute inset-0 w-full h-full animate-float-slow"
      >
        {edges.map(([a, b], i) => {
          const A = nodes[a];
          const B = nodes[b];
          return (
            <line
              key={i}
              x1={A.x}
              y1={A.y}
              x2={B.x}
              y2={B.y}
              stroke="#00E5FF"
              strokeOpacity="0.35"
              strokeWidth="1"
              className="flow-line"
              style={{ animationDelay: `${i * 0.4}s` }}
            />
          );
        })}
        {nodes.map((n, i) => (
          <g key={i}>
            <circle
              cx={n.x}
              cy={n.y}
              r="3"
              fill="#00E5FF"
              className="pulse-node"
              style={{ animationDelay: `${(i % 6) * 0.5}s` }}
            />
            <circle cx={n.x} cy={n.y} r="8" fill="#00E5FF" fillOpacity="0.08" />
          </g>
        ))}
      </svg>

      {/* vignette to anchor text */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(11,19,43,0.2) 0%, rgba(11,19,43,0.55) 60%, rgba(11,19,43,0.95) 100%)",
        }}
      />
    </div>
  );
}
